export default __webpack_public_path__ + "static/media/Arm-straps of the Oxmal.6d99aa6c.jpg";